import { put, call } from 'redux-saga/effects';
import { omit } from 'lodash';
import MulesoftDataService from './../../services/mulesoftData.services';
import { constants } from './../../constants';

import { 
  setPersonalInfoData,
  resetPersonalInfoData,
  updatePersonalInfoFlag,
  toggleAlertShowStatus,
  setShowLoaderStatus} from './../actions';

const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});


export default function * saveProfileData (args) {
  try {
    const base64Encoded = yield call(toBase64, args.payload.document);
    yield call([MulesoftDataService, 'savePersonalInfo'], omit(
      {...args.payload, document: base64Encoded},
     ['dateOfBirth', 'callback']));
   
    const payloadData = {                 
      fileName: args.payload.documentName,
      file: args.payload.document,
      otherFirstName: args.payload.otherFirstName,
      otherLastName: args.payload.otherLastName,
      dateOfBirth: args.payload.dateOfBirth,
      zipCode: args.payload.zipcode
    }
    //making sure redux store will update if api save is successful
    yield put(setPersonalInfoData(payloadData));
    yield put(updatePersonalInfoFlag());
    yield put(setShowLoaderStatus(false));
    args.payload.callback();
  } catch (error) {
    yield put(toggleAlertShowStatus({
      showAlert: true,
      alertVarient:'danger',
      alertMessage: constants.APP_MESSAGE.API_SAVE_ERROR
    }));

    // reseting personal info redux state when api error
    yield put(resetPersonalInfoData());
    yield put(setShowLoaderStatus(false));
  }
}
